import { AuthStorageEnum } from '@dynamic-labs/sdk-api-core';

import type { DynamicClient } from '../../../client/types';
import { assertDefined } from '../../../utils/assertDefined';

/**
 * Returns true if the client is using Dynamic cookies or a BYO JWT cookie.
 */
export const isCookieEnabled = (client: DynamicClient): boolean => {
  assertDefined(client.projectSettings, 'Project settings are not defined');

  const securitySettings = client.projectSettings.security;

  if (!securitySettings) return false;

  // client uses Dynamic cookies
  const dynamicCookiesEnabled = (securitySettings.auth?.storage || []).includes(
    AuthStorageEnum.Cookie
  );

  // BYO JWT client puts their non-Dynamic JWT in a cookie
  const byoJwtCookieEnabled = Boolean(
    securitySettings.externalAuth?.cookieName
  );

  // should return true for both of these scenarios
  // because we also need to do `credentials: true` in api.ts when
  // a byo jwt client sets their named cookie for their jwt and
  // needs to send it to our backend
  return dynamicCookiesEnabled || byoJwtCookieEnabled;
};
